import { formatNumberBasedOnUser } from "utils/namesManipulation";
import { m2 } from "utils/textSymbols";

export const formatTechnicalConfigDrawerSubtitle = (
  count: number,
  countLabel: string,
  area: number
): string =>
  `${formatNumberBasedOnUser(count, 0)} ${countLabel} · ${formatNumberBasedOnUser(area)} ${m2}`;
